import React from "react";
import CustomerOrderDetails from "../../components/user/OrderDetails";
import Layout from "../../components/user/Layout";

function MyOrderDetails() {
  return (
     <Layout>

      <CustomerOrderDetails />

    </Layout>
  );
}

export default MyOrderDetails;
